/* ==========================================================================
   Keep the Shopify Inbox chat launcher ("Χρειάζεστε βοήθεια;") out of the way.

   2026-09-27 (product page, phones): hidden while the size picker /
   add-to-cart / try-on button is on screen.
   2026-10-05 (all pages, all widths; loaded from layout/theme.liquid): also
   hidden while the footer is on screen, because it covered the shop info.
   Open panels (filters, cart, quick add, menus, search, galleries) are
   handled in CSS (assets/elliz-fixes.css) through the classes they already set.

   <html> gets `elliz-chat-away`; the CSS fades the launcher out.
   ========================================================================== */
(function () {
  if (window.__ellizChatAutohide || !('IntersectionObserver' in window)) return;
  window.__ellizChatAutohide = true;

  var mq = window.matchMedia('(max-width: 767px)');
  /* Product page, phones only. */
  var MOBILE_SELECTORS = [
    'variant-selects[id^="variant-selects-"]',
    '#product-container',
    '.genlook-try-on-button'
  ];
  /* Every page, every width. */
  var ALWAYS_SELECTORS = ['footer.elliz-footer'];
  var mobileOnScreen = new Set();
  var alwaysOnScreen = new Set();
  var io = null;

  function apply() {
    var away = alwaysOnScreen.size > 0 || (mq.matches && mobileOnScreen.size > 0);
    document.documentElement.classList.toggle('elliz-chat-away', away);
  }

  function observe() {
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var bucket = e.target.__ellizChatAlways ? alwaysOnScreen : mobileOnScreen;
          if (e.isIntersecting) bucket.add(e.target);
          else bucket.delete(e.target);
        });
        apply();
      });
    }
    function watch(sel, always) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.__ellizChatObserved) return;
        el.__ellizChatObserved = true;
        el.__ellizChatAlways = always;
        io.observe(el);
      });
    }
    MOBILE_SELECTORS.forEach(function (sel) { watch(sel, false); });
    ALWAYS_SELECTORS.forEach(function (sel) { watch(sel, true); });
  }

  function init() {
    observe();
    /* The GenLook button is injected by its app block after load. */
    setTimeout(observe, 1500);
    setTimeout(observe, 4000);
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
